import { render, staticRenderFns } from "./Consultation_mail.vue?vue&type=template&id=cdd78cd2"
import script from "./Consultation_mail.vue?vue&type=script&lang=js"
export * from "./Consultation_mail.vue?vue&type=script&lang=js"
import style0 from "./Consultation_mail.vue?vue&type=style&index=0&id=cdd78cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports